import type { GetStaticPaths, GetStaticProps } from 'next'

export const getStaticPaths: GetStaticPaths = async () => ({ paths: [], fallback: 'blocking' })
export const getStaticProps: GetStaticProps = async () => ({ props: {} })
export { Error404Page as default } from 'general/pages/Error404Page'
